export default "__VITE_ASSET__DfCKHO3t__"